export default "__VITE_ASSET__BtqEJFAW__"